import { localStorageStateBuilder } from "@common/storage/localStorage"
import type { TargetId } from "@common/target/types"
import { MarketSlug } from "@future/market/config/constants"
import type { TargetInfo } from "@future/target/info"
import { domainConfig } from "@future/target/domain"

import type { PerpsRoute } from "./Router"
import { RouteRootId } from "./types"

export const defaultMarketSlug = (targetId: TargetId) => {
  return MarketSlug.get(
    (() => {
      switch (targetId) {
        case "rujidev":
        case "rujibeta":
          return "RUNE_USDT"
        case "rujimainnet1":
          return "RUNE_USDC"
      }
    })(),
  )
}

const visitedTargetMarketSlugKey = "VisitedTargetMarketSlug"

/**
 * Maps from target slug to market slug
 */
export const visitedTargetMarketSlugStorage = localStorageStateBuilder<
  Record<string, string>
>(visitedTargetMarketSlugKey, {} as Record<string, string>)

export const getDefaultTargetInfo = (): TargetInfo => {
  return domainConfig.defaultTargetInfo
}

export const getDefaultMarketSlug = (targetInfo: TargetInfo): MarketSlug => {
  const targetMarketMap = visitedTargetMarketSlugStorage.get()
  if (targetInfo.slug in targetMarketMap) {
    const marketSlugStr = targetMarketMap[targetInfo.slug]
    if (typeof marketSlugStr === "string") {
      return MarketSlug.get(marketSlugStr)
    }
  }
  return defaultMarketSlug(targetInfo.id)
}

export const renderRoute = (dest: PerpsRoute): string => {
  const pathComponents = ((): (string | null)[] => {
    switch (dest.route) {
      case RouteRootId.markets:
        return ["perps", RouteRootId.markets]
      case RouteRootId.trade:
        return ["perps", RouteRootId.trade, dest.marketSlug?.slug ?? null]
      case RouteRootId.earn:
        return ["perps", RouteRootId.earn, dest.marketSlug?.slug ?? null]
      case RouteRootId.history:
        return ["perps", RouteRootId.history]
      case RouteRootId.leaderboard:
        return ["perps", RouteRootId.leaderboard, dest.marketSlug.slug]
      case RouteRootId.stats:
        return ["perps", RouteRootId.stats]
    }
  })()

  return `/${pathComponents.filter(Boolean).join("/")}`
}
